module.exports = __webpack_public_path__ + "static/img/s49.c9705c61.png";